import { Button, DatePicker, Flex, Form, Input, InputNumber, Select } from 'antd'
import { Country } from 'entities/countries/model/types'
import { FC } from 'react'
import { useIntl } from 'react-intl';
import moment from 'moment';
import { Rule } from 'antd/es/form';
import { SignUpFormData } from 'pages/auth/registration/model/types';

type Props = {
  countries: Country[];
  formRules: Record<string, Rule[]>;
  formData: Partial<SignUpFormData>;
}

const currentYear = moment().year();

export const GeneralSection: FC<Props> = ({ countries, formRules, formData }) => {
  const { formatMessage: t } = useIntl();
  return (
    <Form layout='vertical' name='general' initialValues={formData}>
      <Form.Item name='firstName' rules={formRules.firstName}>
        <Input placeholder={t({ id: 'openAccount.modal.info.name' })} />
      </Form.Item>
      <Form.Item name='lastName' rules={formRules.lastName}>
        <Input placeholder={t({ id: 'openAccount.modal.info.surname' })} />
      </Form.Item>
      <Form.Item name='gender' rules={formRules.gender}>
        <Select
          options={[
            {
              value: 'm',
              label: <div id="gender__male">{t({ id: 'inputs.gender.male' })}</div>,
            },
            {
              value: 'f',
              label: <div id="gender__female">{t({ id: 'inputs.gender.female' })}</div>,
            },
          ]}
          placeholder={t({ id: 'inputs.gender' })}
        />
      </Form.Item>
      <Form.Item name='email' rules={formRules.email}>
        <Input placeholder={t({ id: 'openAccount.modal.info.email' })} />
      </Form.Item>
      <Form.Item label={t({ id: 'openAccount.modal.info.date' })}>
        <Flex gap={8}>
          <Form.Item name={['dateOfBirth', 'day']} rules={formRules.dateOfBirth}>
            <InputNumber min={1} max={31} placeholder={t({ id: 'inputs.day' })} />
          </Form.Item>
          <Form.Item name={['dateOfBirth', 'month']} rules={formRules.dateOfBirth}>
            <InputNumber min={1} max={12} placeholder={t({ id: 'inputs.month' })} />
          </Form.Item>
          <Form.Item name={['dateOfBirth', 'year']} rules={formRules.dateOfBirth}>
            <InputNumber min={currentYear - 100} max={currentYear} placeholder={t({ id: 'inputs.year' })} />
          </Form.Item>
        </Flex>
      </Form.Item>
      <Form.Item>
        <Button color="primary" variant='solid' htmlType='submit' block>{t({ id: 'buttons.next' })}</Button>
      </Form.Item>
    </Form>
  )
}